/** Seconds to wait before the `failures`-th retry of the sign-in check: 20 s more each time, capped at 60 s, plus up
 * to 5 s of jitter so an office that failed together does not retry together. `random` is in [0, 1). */
export function retryDelaySeconds(failures: number, random: number = Math.random()): number {
  const base = Math.min(20 * Math.max(1, failures), 60);
  return base + Math.floor(random * 6);
}
